import { render, staticRenderFns } from "./StatsWidget.vue?vue&type=template&id=0c7e1f14&"
import script from "./StatsWidget.vue?vue&type=script&lang=js&"
export * from "./StatsWidget.vue?vue&type=script&lang=js&"
import style0 from "./StatsWidget.vue?vue&type=style&index=0&id=0c7e1f14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports